export default __webpack_public_path__ + "static/sloth_conv-d3321c271c16bedbe4cb62e8ba26f9b8.png";